var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "section-headline col-12 mb-4 d-flex justify-content-between align-items-end"
    },
    [
      _c(
        "h2",
        { staticClass: "font-family__tartine pl-3 pl-md-1 text-secondary" },
        [_vm._v(_vm._s(_vm.msg))]
      ),
      _vm._v(" "),
      _vm.hasEdit
        ? _c("div", [
            !_vm.edit
              ? _c(
                  "p",
                  {
                    staticClass: "edit m-2 pr-1",
                    on: {
                      click: function($event) {
                        return _vm.$emit("click", true)
                      }
                    }
                  },
                  [
                    _vm._v("Bearbeiten "),
                    _c("i", { staticClass: "fad fa-pen" })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }